import React, { useState, useEffect } from 'react';
import Form from '../../../../np-form/Form';
import { withStyles } from '@material-ui/core';
import * as formUtility from '../../../../np-form/utility';
import makeAnimated from 'react-select/animated';
import { snackActions } from '../../../../sc-utilities/SnackBar';
import History from "../../../../../History";

const animatedComponents = makeAnimated();
const styles = theme => ({
    root: {

        padding: '6px',
        width: '91%',
        paddingLeft: '5%'
    }
});

const updateSecondFormState = props => {
    const { classes, customer, selectedCustomer, translations } = props;
    const secondForm = {
        CustomerIDs: {
            elementType: 'multi-select',
            elementConfig: {
                isMulti: true,
                closeMenuOnSelect: false,
                components: animatedComponents,
                type: 'multi-select',
                placeholder: translations['customers'] || ' Customers',
                label: translations['customers'] || ' Customers',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true,
                options: customer ? customer : [],
                selected: selectedCustomer && selectedCustomer.length > 0 ? selectedCustomer.map(p => p) : []
            },
            value: selectedCustomer && selectedCustomer.length > 0 ? selectedCustomer.map(p => p) : [],
            validation: {
                required: true
            },
            valid: true,
            touched: true
        },
    };
    return secondForm;
}

const ChoseCustomer = props => {
    const { classes, translations, setUserFormValid, setActiveStep, customer, setCustomersSelect, onCheckFormParams, activeCustomer, userFormValue, setUserFormValue } = props;
    const [selectedCustomer, setSelectedCustomer] = useState([]);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [customersForm, setCustomerForm] = useState(updateSecondFormState({ translations, customer, selectedCustomer }));

    useEffect(() => {

        setCustomerForm(updateSecondFormState({ translations, customer, selectedCustomer }));
    }, [customer, selectedCustomer, translations, classes]);


    const getMultiSelectData = data => {
        const updateState = formUtility.getNewStateOnMultiSelectChange(data, 'CustomerIDs', customersForm);
        setCustomerForm(updateState.myForm);
        if (data.length === 0) {
            setButtonDisabled(true)
        }
        else {
            setButtonDisabled(false)
        }
        setSelectedCustomer(data)
    }
    const submitHandler = async event => {
        event.preventDefault();
        const formUser = formUtility.getFormData(customersForm);

        // Calling check...
        let checkResponse = await onCheckFormParams({
            ActiveCustomerID: activeCustomer,
            Username: userFormValue.Username.value,
            CustomerIDs: formUser.CustomerIDs
        })

        if (checkResponse && checkResponse.status !== 200 && checkResponse.error && checkResponse.error.errorKey) {
            snackActions.snackBarComponent(checkResponse.message, "warning")
            setUserFormValue({ ...userFormValue, [checkResponse.error.errorKey]: { ...userFormValue[checkResponse.error.errorKey], elementConfig: { ...userFormValue[checkResponse.error.errorKey].elementConfig, error: true } } })
            setActiveStep(0)
            setUserFormValid(false)
            return
        }

        setCustomersSelect(formUser['CustomerIDs'])
        setActiveStep(2)
    };

    const cancelHandler = () => {
        History.goBack();
    };

    return (
        <Form
            formIsValid={!buttonDisabled}
            classes={classes}
            form={customersForm}
            buttonTextCancel={translations['back'] || "Back"}
            cancelHandler={() => setActiveStep(0)}
            getMultiSelectData={getMultiSelectData}
            submitHandler={submitHandler}
            submitButtonColor={'primary'}
            buttonText={translations["next"] || 'NEXT'}
            submitButtonStyle={buttonDisabled ? { color: "#fafafa", borderRadius: '1px' } : { borderRadius: '1px' }}
            handleCancel={cancelHandler}
            buttonCancel={translations["cancel"] || 'Cancel'}
        />

    )
}

export default withStyles(styles, { withTheme: true })(ChoseCustomer);




